import React, { useState } from 'react'
import { Button, Table } from 'antd';
import ZCard from '../../Card/Index'
import { recurringDepositeData } from '../../../utils/JsonData/Recurring_deposit 1';
import { CURRENCY } from '../../../utils/ConstantData';
import CustomAmountText from '../../common/CustomAmountText';
import { TabsEnum } from '../../../utils/Enum/ReportTabsEnum';

const RecurringDepositsPage = ({recurring, onClickTabChange = () => { }}) => {
  return (
    <ZCard>
        <RecurringDepositsTable recurring={recurring} onClickTabChange={onClickTabChange} recurringDeposits={recurringDepositeData.recurringDeposits} />;
    </ZCard>
  )
}

const RecurringDepositsTable = ({ recurring = {}, recurringDeposits, onClickTabChange = () => { } }) => {
  console.log("RECURRING: ", recurring);
  
    // State for pagination
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5, // Default page size
    });
    const columns = [
        {
          title: 'Start Date',
          dataIndex: 'startDate',
          key: 'startDate',
          width: 180
        },
        {
          title: 'End Date',
          dataIndex: 'endDate',
          key: 'endDate',
          width: 180
        },
        {
            title: 'Particulars',
            dataIndex: 'particulars',
            key: 'particulars',
        },
        {
          title: 'Counterparty',
          dataIndex: 'counterparty',
          key: 'counterparty',
        },
        {
          title: `Amount (${CURRENCY})`,
          dataIndex: 'amount',
          key: 'amount',
          align: 'right',
          render: (text) => <CustomAmountText value={text} />,
          width: 180
        },
      {
        title: 'Transaction Count',
        dataIndex: 'transactionCount',
        key: 'transactionCount',
        align: 'center',
        render: (value, record, index) => {
          return (parseFloat(value) > 0 && recurring?.recurringDeposits.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
        },
        width: 180
      },
      {
        title: 'Interval',
        dataIndex: 'interval',
        key: 'interval',
      },
      {
        title: 'Misses',
        dataIndex: 'misses',
        key: 'misses',
      }
    ];

    // Pagination change handler
    const handleTableChange = (pagination) => {
        setPagination(pagination); // Update pagination state with new page and page size
    };
  
    return (
      <Table
        columns={columns}
        dataSource={recurring?.recurringDeposits || []}
        rowKey="accountId" // Assuming accountId is unique
        pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            showSizeChanger: true, // Enable page size changer
            pageSizeOptions: ['5', '10', '20', '50'], // Options for page size
            onChange: (page, pageSize) => {
              setPagination({
                current: page,
                pageSize: pageSize,
              });
            },
        }}
        onChange={handleTableChange}
      />
    );
};
export default RecurringDepositsPage